import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class CompanyInvoiceSettingServiceClass {
    // POST Get with empty body returns settings for logged-in user's company
    get() {
        return BaseService.post(`${APIPath.companyInvoiceSettingGet}`, {})
    }

    // Save (Upsert) settings
    save(data) {
        return BaseService.post(`${APIPath.companyInvoiceSettingSave}`, data)
    }

    // GET number format settings
    getNumberFormat() {
        return BaseService.get(`${APIPath.companyInvoiceNumberFormat}`)
    }

    // Save (PUT) number format settings
    saveNumberFormat(data) {
        return BaseService.put(`${APIPath.companyInvoiceNumberFormat}`, data)
    }

    // POST get number format preview
    getPreview(data) {
        return BaseService.post(`${APIPath.companyInvoiceNumberFormatPreview}`, data)
    }
}

const CompanyInvoiceSettingService = new CompanyInvoiceSettingServiceClass()
Object.freeze(CompanyInvoiceSettingService)
export { CompanyInvoiceSettingService }
